import { useCacheStore } from '@/stores/cache-store'
import { keyBuilderService } from '../../services/key-builder'

/**
 * Cache'den veri alır
 * @param {string} prefix - Cache anahtarı için önek
 * @param {Object} params - Cache anahtarının parametreleri
 * @returns {any|null} Cache değeri veya null
 */
export const get = (prefix, params) => {
  const cacheStore = useCacheStore()
  const key = keyBuilderService.build(prefix, params)
  const data = cacheStore.get(key)
  
  if (data === null) {
    // Cache miss, istatistik için
    if (typeof window !== 'undefined' && window.__CACHE_STATS__) {
      window.__CACHE_STATS__.misses = (window.__CACHE_STATS__.misses || 0) + 1
    }
    
    if (process.env.VUE_APP_MODE === 'development') {
      console.log(`🔴 Cache MISS: ${key}`, { params })
    }
    
    return null
  }
  
  // Cache hit, istatistik için
  if (typeof window !== 'undefined' && window.__CACHE_STATS__) {
    window.__CACHE_STATS__.hits = (window.__CACHE_STATS__.hits || 0) + 1
  }
  
  if (process.env.VUE_APP_MODE === 'development') {
    console.log(`🟢 Cache HIT: ${key}`, { params })
  }
  
  return data
}